module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "prologue",
      "title": "Prologue"
    }
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_vm._v("At 2:41 a.m. on the morning of 7 May 1945 in Reims, France, Lieutenant General Walter B. Smith, U.S. chief of staff of the Supreme Headquarters Expeditionary Force, accepted from General Alfred Jodl the German High Command’s unconditional surrender of German land, sea, and air forces. Accompanying Smith and signing the instrument of surrender were representatives of key Allied forces in the coalition that defeated Fascist Italy and Nazi Germany.")]), _c('a', {
    attrs: {
      "id": "rproen1"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#proen1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" To accommodate Soviet demands and ensure that the Germans did not fight on against the Red Army, a second formal surrender ceremony occurred in Berlin on 9 May. This ceremony culminated a series of surrenders that began in Italy on 29 April and marked the end of the supposed thousand-year German Reich."), _c('a', {
    attrs: {
      "id": "rproen2"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#proen2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Almost four months later, on 2 September 1945 (Far East time), exactly six years to the day from the German invasion of Poland, official hostilities against Japan ended with the formal signing of the instrument of surrender. General of the Army Douglas MacArthur, supreme commander of the Allied Powers, presided over the ceremony on board the U.S.S. "), _c('i', [_vm._v("Missouri")]), _vm._v(" anchored in Tokyo Bay. With him were the representatives of the coalition that had defeated Japan: Australia, China, Canada, France, Netherlands, New Zealand, and the Soviet Union."), _c('a', {
    attrs: {
      "id": "rproen3"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#proen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time of these ceremonies, forces of the Anglo-American coalition within the Grand Alliance had fought a global war on three continents and in a dozen major theaters of operation. Anglo-American armies had battled across Africa and the Mediterranean to the Middle East; from Norway to Italy and the Balkans; from the western tip of France’s Brittany Peninsula to Prague. In the Far East, Allied forces fought in China, Burma, and India and island-hopped from New Guinea to the Netherlands East Indies to the Philippines. Predominantly U.S. forces seized island chain after island chain across the central Pacific, encircling the Japanese home islands. Coalition naval operations swept the seven seas and conducted amphibious assaults on a scale never seen before or since. From the Arctic Ocean to the Cape of Good Hope, from the Gulf of Mexico to the Mediterranean, across the length and breadth of the Pacific Ocean, and throughout the Far East from Pearl Harbor to India to Australia to the Aleutians, Anglo-American naval forces conquered the seas. Royal Air Force and U.S. Army Air Force units supported the land and sea "), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_vm._v("campaigns, and, with sustained bombing campaigns, took the war to the heart of Germany, Italy, and Japan. Millions of men along with tens of thousands of aircraft and thousands of ships engaged in a veritable death struggle with Axis forces. Americans and British would fight in multinational units, oftentimes incorporating units of additional nations. In the end, the armed forces of the coalition led by the United Kingdom and the United States, at great cost (nearly one million dead or missing, millions wounded and displaced, and trillions of dollars spent), achieved victory in what is arguably the most successful military coalition the world has yet known.")])]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Battles and campaigns alone, although vitally important, are never enough to secure victory. Within a coalition, national interests and policies must meld to create grand strategy, which then guides the coalition’s strategy that balances ends, ways, and means to place battles and campaigns in their proper context. The conception, planning, development, and execution of policy and strategy require command-and-control and liaison organizations, processes, and communication channels to coordinate these activities. In a global war, where strategic requirements always exceeded available resources, there had to be mechanisms for ensuring the appropriate allocation of materiel and resources necessary to support strategy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By 1945, the Anglo-American military coalition, the core of the Grand Alliance, had created, modified, and adapted all the organizations, processes, and systems necessary to fight the war together. Nonetheless, these accomplishments did not occur overnight. They had to be initiated, nurtured, and occasionally fought over. The story told in this book is an effort to explain the origins of the Anglo-American coalition, outline its early development, and clarify how this early collaboration set the conditions that led to the Allied victory in 1945.")])])]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40339d76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/13_Prologue.vue
// module id = 93
// module chunks = 0